import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getLocationInputTestIds = createTestIds('location-input', [
  'control',
  ...elements
] as const);
